export const DEFAULT_MAX_SLOTS = 3;
export const INFINITE = Number.MAX_SAFE_INTEGER;
